import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import TopbarWithNavigation from './topbar_with_navigation/TopbarWithNavigation';
import SidebarMobile from './topbar_with_navigation/sidebar_mobile/SidebarMobile';

class Layout extends PureComponent {
  render() {
    return (
      <div>
        <TopbarWithNavigation/>
        <SidebarMobile/>
      </div>
    )
  }
}

export default connect()(Layout);



// WEBPACK FOOTER //
// ./src/pages/_layout/Layout.js